import { render, staticRenderFns } from "./AccountingNavigation.vue?vue&type=template&id=107c27a4&"
import script from "./AccountingNavigation.vue?vue&type=script&lang=js&"
export * from "./AccountingNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports